<template>
  <div class="page-content">
    <MyBreadcrumb :breadcrumb-list="breadcrumbList"></MyBreadcrumb>
    <div class="serviceContent-page">
      <div class="content-title-box">
        <div class="content-title list-title">{{ fromTitle }}</div>
      </div>
      <div class="list-content" v-if="list.length !== 0" style="margin-top: 63px">
        <div
          class="list-content-item"
          v-for="(item, index) of list"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="list-content-item-title">
            <div class="dot"></div>
            <span class="item-title"
              >{{item.title.split('/n').join('')}}</span
            >
          </div>
          <div class="list-content-item-time">{{item.createTime.split(' ')[0]}}</div>
        </div>
      </div>
      <Empty v-else></Empty>
      <MyPagination @current-change="changeCurrent" :total="total"></MyPagination>
    </div>
  </div>
</template>
<script>
import MyBreadcrumb from "@/components/MyBreadcrumb.vue";
import MyPagination from "@/components/MyPagination.vue";
import thematicCollectionDetail from "@/views/detailPage/thematicCollectionDetail.vue";
import {getTopicNewsList} from '@/api'
import Empty from "@/components/Empty.vue";
import EmptyImg from '@/assets/image/common/data-empty.png'
export default {
  components: { Empty, MyPagination, MyBreadcrumb },
  data() {
    return {
      breadcrumbList: [],
      fromTitle: "",
      queryParams:{
        size:8,
        current:1,
        topicId:''
      },
      list:[],
      total:0,
      emptyIcon:EmptyImg
    };
  },
  mounted() {
    this.fromTitle = decodeURI(this.$route.query.from);
    this.queryParams.topicId = this.$route.query.id
    this.breadcrumbList = [
      { title: "专题集萃", url: "/ThematicCollection" },
      { title: this.fromTitle },
    ];
    this.getList()

  },
  methods: {
    toDetail(item) {
      this.$router.push({
        name: "thematicCollectionDetail",
        query: {
          from: encodeURI(this.fromTitle),
          url: encodeURI(
            `/ThematicCollection/list?from=${decodeURI(this.fromTitle)}&id=${this.queryParams.topicId}`
          ),
          id:item.id,
          topicId:item.topicId
        },
      });
    },
    changeCurrent(e) {
      this.queryParams.current = e
      this.getList()
    },
    getList() {
      getTopicNewsList(this.queryParams).then(res=>{
        if (res.code === 200) {
          this.list = res.data.records
          this.total = res.data.total
        }
      })
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables";

.serviceContent-page {
  padding: 0 $pagePadding;
  margin-top: 41px;
}
</style>
